import api from '../api/axiosInstance';

export const deleteEmpleadoService = async (email) => {
    try {
        const response = await api.delete('/propietario/eliminar', {
            params: { correo: email }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error desconocido al eliminar empleado' };
    }
};

